// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"664ab0c1","796":"52f6974f"}[chunkId] + ".chunk.js";
};